import { render, staticRenderFns } from "./ButtonSlideCopy.vue?vue&type=template&id=1dac8ecc&%23action=true"
import script from "./ButtonSlideCopy.vue?vue&type=script&lang=js"
export * from "./ButtonSlideCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports